import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { postNamedCommand } from '../../../../../service'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import SydModal from '../../../../commonDesign/SydModal'
import MeetingForm from './MeetingForm'
import useCategoryOptions from './useCategoryOptions'

const CREATE_DEFAULTS = {
  subject: '',
  start_date: '',
  end_date: '',
  duration: 60,
  all_day: false,
  contacts: [],
  location: '',
  description: '',
  priority: 1,
  repeats: 'never',
  category_id: ''
}

function CreateMeetingModal ({ open, onClose, config, members }) {
  const { clientId } = useAppContext()
  const queryClient = useQueryClient()
  const [bladeOpen, setBladeOpen] = useState(false)

  const categoryOptions = useCategoryOptions(clientId, config?.categoryIds)

  const defaultValues = {
    ...CREATE_DEFAULTS,
    category_id: config?.categoryIds?.[0] ?? ''
  }

  const handleClose = useCallback(() => {
    setBladeOpen(false)
    onClose()
  }, [onClose])

  const { mutateAsync: handleSubmit } = useMutation({
    mutationFn: (body) => postNamedCommand('coreData', 'execute-redtail-domain-command', {
      command: 'createActivity',
      autoResolveConnection: true,
      clientId,
      request: { body }
    }),
    onSuccess: () => {
      handleClose()
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.redtailDomainQuery, 'list-preset']
      })
    }
  })

  return (
    <SydModal
      open={open}
      onClose={handleClose}
      title='Create Meeting'
      size={bladeOpen ? 'large' : 'xmedium'}
      disablePortal={false}
    >
      <MeetingForm
        defaultValues={defaultValues}
        config={config}
        members={members}
        categoryOptions={categoryOptions}
        onSubmit={handleSubmit}
        onCancel={handleClose}
        submitLabel='Create Meeting'
        cancelVariant='outline'
        bladeOpen={bladeOpen}
        onBladeChange={setBladeOpen}
      />
    </SydModal>
  )
}

CreateMeetingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  config: PropTypes.object,
  members: PropTypes.array
}

export default CreateMeetingModal
